class Stack {
    constructor(undo, redo, reset, content, timeOut, functions) {
        this.stack = {};
        this.index = -1;
        this.count = 0;
        this.undoBtn = document.getElementById(undo);
        this.redoBtn = document.getElementById(redo);
        this.resetBtn = document.getElementById(reset);

        if(timeOut === undefined) timeOut = 0;
        this.timeOut = timeOut;
        if(functions === undefined) functions = [];
        this.functions = functions;
        var that = this;

        this.undoBtn.addEventListener("click", function (ev) {
            that.undo();
        }, false);
        this.redoBtn.addEventListener("click", function (ev) {
            that.redo();
        }, false);
        this.resetBtn.addEventListener("click", function (ev) {
            that.reset();
        }, false);

        this.content = {};
        for(var i = 0;i< content.length; i++) {
            this.content[content[i]] = document.getElementById(content[i]);
            this.stack[content[i]] = [];
        }
        this.add();
    }
    canChange() {
        return this.count === 0;
    }
    canRemove() {
        return this.index >= 0;
    }
    add() {
        var that = this;
        this.count++;
        setTimeout(function() {
            that.count--;
            if(!that.canChange()) return false;
            that.index++;
            if(that.canUndo()) {
                that.enableBtn(that.resetBtn);
                that.enableBtn(that.undoBtn);
            }

            for(var property in that.stack) {
                if (that.stack.hasOwnProperty(property)) {
                    that.stack[property].splice(that.index, that.stack[property].length - that.index, that.content[property].innerHTML);
                }
            }
            that.disableBtn(that.redoBtn);
        }, this.timeOut);
    }
    refresh() {
        for(var property in this.stack) {
            if (this.stack.hasOwnProperty(property)) {
                this.stack[property][this.index]=this.content[property].innerHTML;
            }
        }
    }
    canUndo() {
        return this.index >= 1;
    }
    canRedo() {
        return this.index !== this.stack[Object.keys(this.stack)[0]].length - 1;
    }
    undo(times, updateContent) {
        if(!this.canUndo()) return false;
        if(times === undefined) times = 1;
        this.index-=times;
        if(updateContent === undefined) updateContent = true;
        if(updateContent) {
            for(var property in this.content) {
                if (this.content.hasOwnProperty(property)) {
                    this.content[property].innerHTML = this.stack[property][this.index];
                }
            }
        }
        this.enableBtn(this.redoBtn);
        if(!this.canUndo()) {
            this.disableBtn(this.undoBtn);
            this.disableBtn(this.resetBtn);
        }
    }
    redo(times, updateContent) {
        if(!this.canRedo()) return false;
        if(times === undefined) times = 1;
        this.index+=times;
        if(this.index > this.stack[Object.keys(this.stack)[0]].length - 1) return false;
        this.enableBtn(this.undoBtn);
        this.enableBtn(this.resetBtn);
        if(updateContent === undefined) updateContent = true;
        if(updateContent) {
            for(var property in this.content) {
                if (this.content.hasOwnProperty(property)) {
                    this.content[property].innerHTML = this.stack[property][this.index];
                }
            }
        }
        if(!this.canRedo()) this.disableBtn(this.redoBtn);
    }
    reset() {
        if(!this.canUndo()) return false;
        this.index = 0;
        for(var property in this.content) {
            if (this.content.hasOwnProperty(property)) {
                this.stack[property].splice(1);
                this.content[property].innerHTML = this.stack[property][0];
            }
        }
        this.disableBtn(this.undoBtn);
        this.disableBtn(this.redoBtn);
        this.disableBtn(this.resetBtn);
    }

    enableBtn(btn) {
        btn.classList.remove( "disabled" );
    }

    disableBtn(btn) {
        btn.classList.add( "disabled" );
    }
}

export default Stack
window.Stack = Stack;
